<template>
  <div class="tested-orders">
    <base-status-orders
      :status="'TESTED'"
      :title="'已测试订单'"
      :show-actions="true">
      <template #actions="{ row }">
        <el-button 
          type="primary" 
          size="mini" 
          @click="handleViewResult(row)">查看结果</el-button>
        <el-button 
          type="warning" 
          size="mini" 
          @click="handleDispute(row)">申请争议</el-button>
      </template>
    </base-status-orders>
    
    <!-- 测试结果对话框 -->
    <el-dialog
      title="测试结果"
      :visible.sync="resultDialogVisible"
      width="600px">
      <div class="result-info">
        <div class="info-item">
          <span class="label">测试说明：</span>
          <span class="value">{{ currentResult.testDescription }}</span>
        </div>
        <div class="info-item">
          <span class="label">提交时间：</span>
          <span class="value">{{ currentResult.createTime }}</span>
        </div>
      </div>
      
      <!-- 测试结果附件列表 -->
      <div v-if="currentResult.testFiles && currentResult.testFiles.length > 0" class="result-files">
        <h3 class="file-list-title">测试结果附件</h3>
        <el-table
          :data="currentResult.testFiles"
          style="width: 100%"
          border>
          <el-table-column
            prop="name"
            label="文件名"
            min-width="300">
          </el-table-column>
          <el-table-column
            prop="size"
            label="大小"
            width="150">
            <template slot-scope="scope">
              {{ formatFileSize(scope.row.size) }}
            </template>
          </el-table-column>
          <el-table-column
            label="操作"
            width="150"
            align="center">
            <template slot-scope="scope">
              <el-button 
                type="text" 
                size="small" 
                @click="handlePreview(scope.row)">预览</el-button>
              <el-button 
                type="text" 
                size="small" 
                @click="handleDownload(scope.row)"
                style="margin-left: 10px;">下载</el-button>
            </template>
          </el-table-column>
        </el-table>
      </div>
      
      <div slot="footer" class="dialog-footer">
        <el-button @click="resultDialogVisible = false">关闭</el-button>
        <el-button 
          type="warning" 
          @click="handleDisputeFromDialog">提交争议</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import BaseStatusOrders from './BaseStatusOrders.vue'
import adminApi from '@/api/adminApi'

export default {
  name: 'TestedOrders',
  components: {
    BaseStatusOrders
  },
  data() {
    return {
      resultDialogVisible: false,
      currentResult: {
        testDescription: '',
        createTime: '',
        testFiles: [],
        orderId: null
      }
    }
  },
  methods: {
    handleViewResult(row) {
      // 获取测试结果信息
      this.currentResult = {
        testDescription: row.testResultRemark || '',
        createTime: row.testResultCreateTime || '',
        testFiles: row.orderResultFileList || [],
        orderId: row.id
      }
      this.resultDialogVisible = true
    },
    handleDispute(row) {
      // 弹出确认框，让用户选择是申请争议还是复测
      this.$confirm('请选择申请类型', '提示', {
        confirmButtonText: '提出争议',
        cancelButtonText: '申请复测',
        type: 'warning',
        distinguishCancelAndClose: true,
        callback: (action) => {
          if (action === 'confirm') {
            // 跳转到争议提交页面（统一使用步骤条）
            this.$router.push({
              path: `/admin/orders/management/${row.id}`,
              query: {
                step: 'SUBMIT_DISPUTE',
                action: 'dispute'
              }
            })
          } else if (action === 'cancel') {
            // 跳转到复测结果上传页面
            this.$router.push({
              path: `/admin/orders/management/${row.id}`,
              query: {
                step: 'SUBMIT_RETEST',
                action: 'retest'
              }
            })
          }
        }
      })
    },
    
    // 从结果对话框跳转到争议提交
    handleDisputeFromDialog() {
      // 关闭结果对话框，跳转到争议提交页面（统一使用步骤条）
      this.resultDialogVisible = false
      if (this.currentResult.orderId) {
        this.$router.push({
          path: `/admin/orders/management/${this.currentResult.orderId}`,
          query: {
            step: 'SUBMIT_DISPUTE',
            action: 'dispute'
          }
        })
      } else {
        this.$message.error('获取订单ID失败，无法跳转')
      }
    },
    formatFileSize(size) {
      if (!size) return '0 B'
      const units = ['B', 'KB', 'MB', 'GB']
      let index = 0
      while (size >= 1024 && index < units.length - 1) {
        size /= 1024
        index++
      }
      return size.toFixed(2) + ' ' + units[index]
    },
    handlePreview(file) {
      // 调用统一的预览方法
      adminApi.previewFile(file, this.$message)
        .catch(error => {
          console.error('文件预览失败:', error);
        });
    },
    handleDownload(file) {
      // 调用统一的下载方法
      adminApi.downloadFileUnified(file, this.$message)
        .catch(error => {
          console.error('文件下载失败:', error);
        });
    }
  }
}
</script>

<style scoped>
.tested-orders {
  width: 100%;
  height: 100%;
  padding: 20px;
  box-sizing: border-box;
}

.result-info {
  margin-bottom: 20px;
  padding: 15px;
  background-color: #f0f9eb;
  border-radius: 4px;
  color: #67c23a;
}

.info-item {
  margin-bottom: 10px;
}

.info-item .label {
  font-weight: bold;
  margin-right: 10px;
}

.result-files {
  margin-top: 20px;
}

.file-list-title {
  margin: 0 0 20px 0;
  font-size: 16px;
  color: #303133;
  position: relative;
  padding-left: 12px;
}

.file-list-title:before {
  content: '';
  position: absolute;
  left: 0;
  top: 50%;
  transform: translateY(-50%);
  width: 4px;
  height: 16px;
  background-color: #409eff;
  border-radius: 2px;
}
</style> 